export default __webpack_public_path__ + "static/108015-b2e224078f8e76c0999bfe48e10774bf.jpg";